
import Vue from 'vue'

import AVISessionTransformer from '@/transformers/chat'

export default () =>
  Vue.$http.post('avi_chat/login/')
    .then(response => AVISessionTransformer.fetch(response.data))
